<div class="blockEdisor">
    <h2 mat-dialog-title>Edytor bloku</h2>
    <div mat-dialog-content class="workspace">
      <!-- ► TRYB WIZUALNY  -->
      <div #canvas class="canvas" *ngIf="!sourceMode" [innerHTML]="clonedHtml"></div>
    
      <!-- ► TRYB ŹRÓDŁA  -->
      <mat-form-field style="width: 100%;" class="code-area" *ngIf="sourceMode" appearance="fill">
        <textarea matInput
                  cdkTextareaAutosize
                  [(ngModel)]="source"
                  spellcheck="false"
                  rows="15"></textarea>
      </mat-form-field>
    
      <!-- TOOLBAR -->
      <div class="toolbar">
        <!-- Przesuwanie -->
        <section class="move">
          <button (click)="move('up')">↑</button>
          <button (click)="move('down')">↓</button>
          <button (click)="move('left')">←</button>
          <button (click)="move('right')">→</button>
        </section>
    
        <!-- Upload obrazka tylko w trybie wizualnym -->
        <section *ngIf="!sourceMode" style="cursor: pointer;">
          <label class="file-btn">📷
            <input type="file" accept="image/*" (change)="onFile($event)" />
          </label>
        </section>
    
        <!-- Przełącznik Tekst/Kod -->
        <section>
          <button (click)="toggleSource()">
            {{ sourceMode ? '🔤 Tekst' : '💻 Kod' }}
          </button>
        </section>
    
        <!-- Dodaj blok -->
        <section *ngIf="!sourceMode">
          <button (click)="addBlock()">➕ Blok</button>
        </section>
      </div>
    </div>
    
    <div align="end">
      <button mat-button (click)="dialogRef.close()">Anuluj</button>
      <button mat-flat-button color="primary" (click)="apply()">Zastosuj</button>
    </div>
</div>
